import { render } from "./Container.vue?vue&type=template&id=2a63260e&scoped=true"
import script from "./Container.vue?vue&type=script&lang=ts"
export * from "./Container.vue?vue&type=script&lang=ts"

import "./Container.vue?vue&type=style&index=0&id=2a63260e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a63260e"

export default script